export const ModuleStatusList = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Hidden",
    value: "hidden",
  },
  {
    label: "Coming Soon",
    value: "comingSoon",
  },
  {
    label: "Maintenance",
    value: "maintenance",
  },
];
